<template>
  <div>
    <v-card>
      <v-snackbar
        v-model="sbAsignar"
        :timeout="timeout"
        :top="true"
        :absolute="true"
        color="#333333"
      >
        {{ mensajeSbAsignar }}
        <v-btn color="green" text small @click="sbAsignar = false">
          Cerrar
        </v-btn>
      </v-snackbar>

      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-format-list-checks</v-icon>
          GUIAS EN RESERVA WEB
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-5"
        >
        </v-text-field>
        <v-spacer></v-spacer>

        <v-select
          v-model="filtroEtiquetas"
          :items="etiquetas"
          label="Etiquetas"
          item-value="id"
          item-text="desc"
          multiple
          chips
          persistent-hint
          class="mt-2"
          single-line
          @change="cargarLista()"
        ></v-select>
        <v-spacer></v-spacer>
        <v-select
          v-model="filtroEstado"
          :items="estados"
          label="Estado"
          item-value="id"
          item-text="desc"
          persistent-hint
          class="mt-2"
          single-line
          clearable
          @change="cargarLista()"
        ></v-select>
      </v-toolbar>

      <!-- <v-toolbar>
        <v-toolbar-title>Etiquetas</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-spacer></v-spacer>
      </v-toolbar> -->

      <v-toolbar color="white">
        <v-btn small class="primary mx-1" @click="formAsignarVariedad()"
          >Asignar Variedad</v-btn
        >
        <v-btn small class="primary mx-2" @click="asignarCoordWeb()"
          >Coordinación web</v-btn
        >
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :search="busqueda"
        :loading="loadingTable"
        class="elevation-1"
        show-select
        v-model="seleccion"
        item-key="CABECERA_ID"
      >
        <template v-slot:item.opcion="{ item }">
          <!-- <v-btn text title="editar tipo de guia" @click="abrirGuia(item)">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn> -->
        </template>

        <template v-slot:item.RESERVA_AUTO="{ item }">
          <v-chip
            title="reserva automática"
            v-if="item.RESERVA_AUTO == 'A'"
            small
            class="ma-1"
            color="yellow"
            @click="abrirGuia(item)"
          >
            {{ item.RESERVA_AUTO }}
          </v-chip>
          <v-btn
            v-if="item.RESERVA_AUTO == null"
            text
            title="editar tipo de guia"
            @click="abrirGuia(item)"
          >
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.IDENT_BIENES="{ item }">
          <v-chip
            title="consolidado"
            v-if="item.IDENT_BIENES == 'CONS'"
            small
            class="ma-1"
            color="red"
            text-color="white"
            @click="abrirGuia(item)"
          >
            C
          </v-chip>
          <v-chip
            title="simple"
            v-if="item.IDENT_BIENES == 'FF'"
            small
            class="ma-1"
            color="purple"
            text-color="white"
            @click="abrirGuia(item)"
          >
            S
          </v-chip>

          <v-chip
            title="encargo"
            v-if="item.IDENT_BIENES == 'ENC'"
            small
            class="ma-1"
            color="black"
            text-color="white"
            @click="abrirGuia(item)"
          >
            E
          </v-chip>

          <v-btn
            v-if="item.IDENT_BIENES == null"
            text
            title="editar tipo de guia"
            @click="abrirGuia(item)"
          >
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.params_coord="{ item }">
          <span v-for="i in item.params_coord">
            <v-chip
              v-if="i.TIPO_PARAM == 'COORD_WEB'"
              small
              class="ma-1"
              close
              color="green"
              @click:close="eliminarOpcion(i.PARAM_COORD_ID)"
            >
              {{ i.VALOR_PARAM }}
            </v-chip>

            <v-chip
              v-if="i.TIPO_PARAM == 'VARIEDAD'"
              small
              class="ma-1"
              close
              :color="colorVariedad(i.VALOR_PARAM)"
              @click:close="eliminarOpcion(i.PARAM_COORD_ID)"
            >
              {{ i.VALOR_PARAM }}
            </v-chip>
          </span>
        </template>
        <template v-slot:item.CLIENTE_NOMBRE="{ item }">
          {{ item.CLIENTE_NOMBRE }} {{ item.MARCACION }}
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="formAsignar" persistent max-width="550px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formAsignarTitulo }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formAsignar">
              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-autocomplete
                    v-model="variedadSel"
                    small
                    item-text="VARIEDAD"
                    item-value="VARIEDAD"
                    :items="variedades"
                    label="Variedades"
                    cache-items
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn color="primary" @click="asignarVariedad()">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            <v-btn @click="formAsignar = !formAsignar">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGuia" persistent max-width="550px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogGuiaTitulo }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formGuia">
              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-checkbox
                    label="Reserva automática"
                    small
                    v-model="resAuto"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-select
                    v-model="tipoGuiaSel"
                    small
                    item-text="tipoGuiaDesc"
                    item-value="tipoGuiaId"
                    :items="tiposGuia"
                    label="Tipo de guia"
                    cache-items
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small class="mx-1" color="primary" @click="actualizarGuia()">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            <v-btn small class="mx-1" @click="dialogGuia = !dialogGuia">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { timeout } from "q";

export default {
  name: "ListaMawbCoordComponent",
  data: () => ({
    headers: [
      { text: "Opcion", value: "opcion" },
      { text: "Confirma. Auto.", value: "RESERVA_AUTO" },
      { text: "Tipo", value: "IDENT_BIENES" },
      { text: "AWB", value: "AWB" },
      { text: "Opciones para coordinar", value: "params_coord" },
      { text: "Fecha", value: "FECHA" },
      { text: "Cliente", value: "CLIENTE_NOMBRE" },
      { text: "Aerolinea", value: "AEROLINEA_NOMBRE" },
      { text: "Estado", value: "ESTADO_GUIA" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    lista: [],
    seleccion: [],
    options: {},
    estados: [
      { id: "ABIERTA", desc: "ABIERTA" },
      { id: "RESERVADA", desc: "RESERVADA" },
      { id: "CERRADA", desc: "CERRADA" },
    ],
    notifications: false,
    //sound: true,
    //widgets: true,
    formAsignar: false,
    busqueda: null,
    formAsignarTitulo: "",
    variedades: ["ROSAS", "FLOR DE VERANO", "CONTENEDOR1", 
                "CONTENEDOR2", "CONTENEDOR3", "CONTENEDOR4", "CONTENEDOR5", "CONTENEDOR6", "CONTENEDOR7", "CONTENEDOR8", "CONTENEDOR9", "CONTENEDOR10", "CONTENEDOR11", "CONTENEDOR12" ,
                "GUIA1", "GUIA2", "GUIA3" ,
                "COLOUR1", "COLOUR2", "COLOUR3", "COLOUR4", "COLOUR5", "COLOUR6", "COLOUR7", "COLOUR8", "COLOUR9", "COLOUR10", "COLOUR11", "COLOUR12", "COLOUR13", "COLOUR14", "COLOUR15", "COLOUR16", "COLOUR17", "COLOUR18", "COLOUR19", "COLOUR20"
              ],
    datosDae: [],
    itemsPerPage: 20,
    hcoordsAbiertas: [],
    variedadSel: "",
    filtroEstado: "",
    varcol: [
      { var: "ROSAS", color: "#ff3471" },
      { var: "FLOR DE VERANO", color: "#2267FF" },
      { var: "CONTENEDOR1", color: "#ff3471" },
      { var: "CONTENEDOR2", color: "#ff3471" },
      { var: "CONTENEDOR3", color: "#ff3471" },
      { var: "CONTENEDOR4", color: "#ff3471" },
      { var: "CONTENEDOR5", color: "#ff3471" },
      { var: "CONTENEDOR6", color: "#ff3471" },
      { var: "CONTENEDOR7", color: "#ff3471" },
      { var: "CONTENEDOR8", color: "#ff3471" },
      { var: "CONTENEDOR9", color: "#ff3471" },
      { var: "CONTENEDOR10", color: "#ff3471" },
      { var: "CONTENEDOR11", color: "#ff3471" },
      { var: "CONTENEDOR12", color: "#ff3471" },
      { var: "GUIA1", color: "#7f6b71" },
      { var: "GUIA2", color: "#7f6b71" },
      { var: "GUIA3", color: "#7f6b71" },
      { var: "COLOUR1", color: "#248698" },
      { var: "COLOUR2", color: "#248698" },
      { var: "COLOUR3", color: "#248698" },
      { var: "COLOUR4", color: "#248698" },
      { var: "COLOUR5", color: "#248698" },
      { var: "COLOUR6", color: "#248698" },
      { var: "COLOUR7", color: "#248698" },
      { var: "COLOUR8", color: "#248698" },
      { var: "COLOUR9", color: "#248698" },
      { var: "COLOUR10", color: "#248698" },
      { var: "COLOUR11", color: "#248698" },
      { var: "COLOUR12", color: "#248698" },
      { var: "COLOUR13", color: "#248698" },
      { var: "COLOUR14", color: "#248698" },
      { var: "COLOUR15", color: "#248698" },
      { var: "COLOUR16", color: "#248698" },
      { var: "COLOUR17", color: "#248698" },
      { var: "COLOUR18", color: "#248698" },
      { var: "COLOUR19", color: "#248698" },
      { var: "COLOUR20", color: "#248698" },
    ],

    etiquetas: [
      { id: "ROSAS", desc: "ROSAS" },
      { id: "FLOR DE VERANO", desc: "FLOR DE VERANO" },
      { id: "CONTENEDOR1", desc: "CONTENEDOR 1" },
      { id: "CONTENEDOR2", desc: "CONTENEDOR 2" },
      { id: "CONTENEDOR3", desc: "CONTENEDOR 3" },
      { id: "CONTENEDOR4", desc: "CONTENEDOR 4" },
      { id: "CONTENEDOR5", desc: "CONTENEDOR 5" },
      { id: "CONTENEDOR6", desc: "CONTENEDOR 6" },
      { id: "CONTENEDOR7", desc: "CONTENEDOR 7" },
      { id: "CONTENEDOR8", desc: "CONTENEDOR 8" },
      { id: "CONTENEDOR9", desc: "CONTENEDOR 9" },
      { id: "CONTENEDOR10", desc: "CONTENEDOR 10" },
      { id: "CONTENEDOR11", desc: "CONTENEDOR 11" },
      { id: "CONTENEDOR12", desc: "CONTENEDOR 12" },
      { id: "COORDINACION WEB", desc: "COORDINACION WEB" },
      { id: "GUIA1", desc: "GUIA1" },
      { id: "GUIA2", desc: "GUIA2" },
      { id: "GUIA3", desc: "GUIA3" },
       
      { id: "COLOUR1", desc: "COLOUR1" },
      { id: "COLOUR2", desc: "COLOUR2" },
      { id: "COLOUR3", desc: "COLOUR3" },
      { id: "COLOUR4", desc: "COLOUR4" },
      { id: "COLOUR5", desc: "COLOUR5" },
      { id: "COLOUR6", desc: "COLOUR6" },
      { id: "COLOUR7", desc: "COLOUR7" },
      { id: "COLOUR8", desc: "COLOUR8" },
      { id: "COLOUR9", desc: "COLOUR9" },
      { id: "COLOUR10", desc: "COLOUR10" },
      { id: "COLOUR11", desc: "COLOUR11" },
      { id: "COLOUR12", desc: "COLOUR12" },
      { id: "COLOUR13", desc: "COLOUR13" },
      { id: "COLOUR14", desc: "COLOUR14" },
      { id: "COLOUR15", desc: "COLOUR15" },
      { id: "COLOUR16", desc: "COLOUR16" },
      { id: "COLOUR17", desc: "COLOUR17" },
      { id: "COLOUR18", desc: "COLOUR18" },
      { id: "COLOUR19", desc: "COLOUR19" },
      { id: "COLOUR20", desc: "COLOUR20" },
      
    ],
    filtroEtiquetas: [],
    dialogGuia: false,
    dialogGuiaTitulo: "Guia aerea",
    tiposGuia: [
      { tipoGuiaId: "CONS", tipoGuiaDesc: "CONSOLIDADO" },
      { tipoGuiaId: "FF", tipoGuiaDesc: "SIMPLE" },
      { tipoGuiaId: "ENC", tipoGuiaDesc: "ENCARGO" },
    ],
    tipoGuiaSel: "",
    resAuto: "",
    datosGuia: { awb: "", ident_bienes: "", res_auto: "" },
    sbAsignar: false,
    mensajeSbAsignar: "",
    timeout: 3000,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),

    ...mapGetters("access", []),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    colorVariedad(x) {
      for (let i = 0; i <= this.varcol.length; i++) {
        if (this.varcol[i].var == x) {
          return this.varcol[i].color;
        }
      }
    },
    asignarCoordWeb() {
      console.log(this.seleccion);
      let cont = 0;
      for (let i = 0; i < this.seleccion.length; i++) {
        if (this.seleccion[i].ABIERTA == 0) {
          cont++;
        }
      }

      let cont2 = 0;
      for (let i = 0; i < this.seleccion.length; i++) {
        if (
          this.seleccion[i].IDENT_BIENES == "" ||
          this.seleccion[i].IDENT_BIENES == null
        ) {
          cont2++;
        }
      }

      if (cont > 0) {
        alert("Solo se pueden asignar guias ABIERTAS ");
        return false;
      }

      if (cont2 > 0) {
        alert("Ingrese el tipo de guía para poder asignar ");
        return false;
      }

      this.setUrl("api/asignar-coord-web");
      this.requestApi({
        method: "POST",
        data: {
          guias: this.seleccion,
        },
      })
        .then((res) => {
          //console.log(res);
          this.cargarLista();
          this.seleccion = [];
          this.mensajeSbAsignar = "Guia asignada a coordinación web";
          this.sbAsignar = true;
        })
        .catch(() => {})
        .then(() => {
          this.formDae = false;
        });
    },

    asignarVariedad() {
      console.log(this.seleccion);

      this.setUrl("api/asignar-param-variedad");
      this.requestApi({
        method: "POST",
        data: {
          guias: this.seleccion,
          variedad: this.variedadSel,
        },
      })
        .then((res) => {
          console.log(res);
          this.cargarLista();
          this.seleccion = [];
        })
        .catch(() => {})
        .then(() => {
          this.formAsignar = false;
        });
    },

    formAsignarVariedad() {
      this.formAsignar = true;
    },

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-mawb-coord");
      this.requestApi({
        method: "GET",
        data: { etiquetas: this.filtroEtiquetas, estados: this.filtroEstado },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data.lista;

          this.pageCount = 10;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    eliminarOpcion(ID) {
      Vue.swal({
        html: "Está seguro de eliminar la opción ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setUrl("api/borrar-param-coord-guia");
          this.requestApi({
            method: "DELETE",
            data: {
              PARAM_COORD_ID: ID,
            },
          }).then((res) => {
            this.alertNotification({ param: { html: res.data.msg } });

            this.cargarLista();
            //let obj = this.permisos.find(e => e.permission_id == permissionId)
            //let index = this.permisos.indexOf(obj)
            //this.permisos.splice(index,1)
          });
        }
      });
    },
    abrirGuia(guia) {
      this.dialogGuia = true;
      this.setUrl("api/cargar-guia");
      this.requestApi({
        method: "POST",
        data: {
          awb: guia.AWB,
        },
      })
        .then((res) => {
          //console.log(res.data.datos_guia[0]);
          this.datosGuia.awb = res.data.datos_guia[0].AWB;
          this.datosGuia.ident_bienes = res.data.datos_guia[0].IDENT_BIENES;
          this.tipoGuiaSel = res.data.datos_guia[0].IDENT_BIENES;
          this.resAuto =
            res.data.datos_guia[0].RESERVA_AUTO != null ? "A" : null;
        })
        .catch(() => {})
        .then(() => {
          //this.formDae = false;
        });
    },

    actualizarGuia() {
      this.setUrl("api/actualizar-guia");
      this.requestApi({
        method: "POST",
        data: {
          awb: this.datosGuia.awb,
          ident_bienes: this.tipoGuiaSel,
          res_auto: this.resAuto == true ? "A" : null,
        },
      })
        .then((res) => {
          //console.log(res);
          this.dialogGuia = false;
          this.datosGuia = { awb: "", ident_bienes: "", res_auto: "" };
          this.tipoGuiaSel = "";
          this.resAuto = "";
          this.mensajeSbAsignar = "Guia actualizada con éxito";
          this.sbAsignar = true;
          this.cargarLista();
        })
        .catch(() => {})
        .then(() => {});
    },
  },
  mounted() {
    this.cargarLista();
  },
};
</script>
